<template>
    <Forms ref="searchAnnouncements"
            :title="'Busca por Comunicado'"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load="onLoad"
    >
        <div>
            <div id="form-search">
            <label class="labelsearch">Comunicado</label>
              <!-- <input v-model="SearchDados.comunicado" class="form-control" placeholder="Digite o nome do comunicado"> -->

              <autocomplete-z ref="ComunicadoTypeahead"
                    placeholder="Digite o nome do comunicado"
                    iconClass="fas fa-bullhorn"
                    :serializer="(comunicado) => comunicado.titulo"
                    :debounceLength="2"
                    :formField="SearchDados.comunicado"
                    v-on:search="onSearchComunicado"
                    v-on:changeCode="onChangeCodeComunicado"
                    :ShowCode="false"
                    />

              <label class="labelsearch mt-3"> Filtrar por </label>
              <select
              v-model="SearchDados.tipoPesquisa"
              class="form-control"
              id="exampleFormControlSelect2"
            >
            <option value = "null"> Todos </option>
            <option value= "1"> Geral </option>
            <option value= "2"> Empreendimento </option>
              </select>

            <label v-show="SearchDados.tipoPesquisa == 2" class = "labelsearch mt-3">Empreendimento </label>
              <select v-show="SearchDados.tipoPesquisa == 2"
                v-model="SearchDados.empreendimentoId"
                class="form-control"
                id="exampleFormControlSelect2"
              >
                <option disabled value="null"> Selecione um empreendimento</option>
                <option v-for="search in empreendimento" v-bind:key="search.value" :value="search.value">{{search.text}}</option>
              </select>

            <label class="labelsearch mt-3">Aplicativo</label>
              <select v-model="SearchDados.aplicativo" class="form-control" id="selectPagamento">
                    <option disabled value="null"> Selecione um Aplicativo</option>
                    <option v-for="app in aplicativos" :key="app.value" :value="app.value">{{app.text}}</option>
              </select>
            <label class="labelsearch mt-3" for="txtInsured">Data de Envio</label>

              <div class="labelsearch mt-3" for="txtInsured">Desde</div>
              <div class="margem d-flex align-items-end">
                <b-form-datepicker
                  v-model="SearchDados.dataInicio"
                  ref="dataInicio"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
              <label class="labelsearch mt-3" for="txtInsured">Até</label>
              <div class="d-flex align-items-end">
                  <b-form-datepicker
                  v-model="SearchDados.dataFim"
                  ref="dataFim"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
            </div>
        </div>
    </Forms>
</template>

<script>

import searchAnnouncements from './searchAnnouncements'
export default searchAnnouncements

</script>

<style scoped>
.margem{
  margin-bottom: 0.5rem;
}

.labelsearch{
  font-weight: 700;
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0;
  font-family: Segoe UI;
}

#text{
  font-size: 70px;
}

#app.zopone .text-third{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/announcements/components/searchAnnouncements/searchAnnouncements.vue